module.exports = __webpack_public_path__ + "img/options-dessert-guide.4a454130.png";